import React from 'react'
import { Link } from 'react-router-dom'
import DateDisplay from 'src/components/DateDisplay'
import { dates } from 'src/helpers/displayhelpers'

/**
 * Renders a date value using the shared DateDisplay component.
 * Handles null/undefined gracefully by rendering nothing.
 */
export const renderDate = (_field: string, value: any): React.ReactNode => {
  if (value == null) return null
  return <DateDisplay date={value} />
}

/**
 * Formats a date value as a locale date string for CSV export.
 * Returns an empty string for null/undefined values.
 */
export const exportFormatDate = (_field: string, value: any): string => {
  if (value == null) return ''
  return dates.dateOnly(value)
}

/**
 * Returns a render function that links the field value to a record page.
 * The path is built using the row's _id field.
 */
export const renderLink = (basePath: string) => (_field: string, value: any, row: any): React.ReactNode => {
  if (value == null) return null
  return <Link to={`${basePath}/${String(row._id)}`} target='_blank' rel='noopener noreferrer'>{value}</Link>
}
